// extracted by mini-css-extract-plugin
export default {"timerContainer":"CircularTimer_timerContainer__t4rbq","timerBackground":"CircularTimer_timerBackground__4AOX4","timerProgress":"CircularTimer_timerProgress__CRlVe"};